import { PolygonType, ScreeningFlag } from '../enums';
import { Activity, Industry } from '.';

export class ScreeningResultHistoryItem {
    public id: string;
    public locationId: string;
    public screeningId: string;
    public createdAt: Date;
    public compoundName: string;
    public compoundCasNr: string;
    public concentration: number;
    public qualityCriterion: number;
    public excessFactor: number;
    public polygonType: PolygonType;
    public polygonArea: number;
    public industry: Industry;
    public activity: Activity;
    public flag: ScreeningFlag;

    public dataTarget: string;
    public formattedDate: string;

    public constructor(init: Partial<ScreeningResultHistoryItem>) {
        Object.assign(this, init);
    }
}
